// extracted by mini-css-extract-plugin
export default {"root":"RadioCard_root__oGEjW","label":"RadioCard_label__XbZCz","description":"RadioCard_description__uIc6F"};